import React from 'react';
import { List } from 'semantic-ui-react';
import { NO_LABEL } from './utils';
import './HoursOfOperationLabeled.css';
var defaultProps = {
  isHorizontal: false,
  animated: false,
  celled: false,
  inlineHours: false
};
export default function HoursOfOperationLabeled(_ref) {
  var data = _ref.data,
      isHorizontal = _ref.isHorizontal,
      animated = _ref.animated,
      celled = _ref.celled,
      inlineHours = _ref.inlineHours;
  return /*#__PURE__*/React.createElement(List, {
    horizontal: isHorizontal,
    animated: animated,
    celled: celled,
    relaxed: true
  }, data.map(function (labelData) {
    var mainLabel = labelData[0];
    var hoursData = labelData[1];
    var mainList = /*#__PURE__*/React.createElement(List.List, null, hoursData.map(function (_ref2, idx) {
      var secondaryLabel = _ref2.secondaryLabel,
          hoursValue = _ref2.hoursValue;
      return /*#__PURE__*/React.createElement(List.Item, {
        key: secondaryLabel,
        style: !!secondaryLabel && idx !== 0 ? {
          marginTop: '1em'
        } : {
          marginTop: '0.25em'
        }
      }, /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement(List.Header, {
        as: "h6"
      }, secondaryLabel, inlineHours && ": ".concat(hoursValue.join(' | '))), !inlineHours && /*#__PURE__*/React.createElement(List.Description, null, /*#__PURE__*/React.createElement("ul", {
        className: "unstyled-list"
      }, hoursValue.map(function (hour) {
        return /*#__PURE__*/React.createElement("li", {
          key: hour
        }, hour);
      })))));
    }));
    return /*#__PURE__*/React.createElement(List.Item, null, /*#__PURE__*/React.createElement(List.Content, null, mainLabel !== NO_LABEL && /*#__PURE__*/React.createElement(List.Header, {
      as: "header",
      className: "h5"
    }, mainLabel), mainList));
  }));
}
HoursOfOperationLabeled.defaultProps = defaultProps;